import axios from "axios";
const SERVERBASEURL = process.env.REACT_APP_API;
const config = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "application/json",
  },
};

export async function getLedgerList(params) {
    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`
    const d = await axios.get(
      SERVERBASEURL + "/LedgerList",
      {
        ...config,
        params: params
      }
      );
    return d;
  }


  export async function getLedgerExcel(params) {
    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`
    const d = await axios.get(
      SERVERBASEURL + "/LedgerList/createExcel",
      {
        ...config,
        params: params
      }
      );
    return d;
  }